<template>
        <div class="form-group filtreNbrPage" v-if="nbrResultatsParPage">
    		<label for="filtre_nombre_resultats_par_page">Nombre par page</label>
    		<select id="filtre_nombre_resultats_par_page" class="form-control form-control-sm" v-model="nbrResultatsParPage" @change="onChangeNbrResultats()">
                <option value="10" selected>10</option>
                <option value="25">25</option>
    		</select>
        </div>
</template>

<script>
    export default{
        name:"NombreResultatsParPage",
        components: {
            
        },
        emits: ['changerNombreResultatsParPage'],
        props: {
            nbrResultats: {
                type: Number
            }
        },
        data(){
          return{
            nbrResultatsParPage: 10
          }
        }, 
        methods:{
            onChangeNbrResultats(){
			    let nbrResultatsParPage=this.nbrResultatsParPage;
			    this.$emit('changerNombreResultatsParPage',nbrResultatsParPage);
            },
        },
        computed: {
            
        }
    }
</script>